// import React, { useState } from 'react';
// import { X, Eye, EyeOff } from 'lucide-react';
// import UserLogin from './UserLogin';
// import GoogleUserLoginButton from './GoogleUserLoginButton';
// import { registerUser } from '../api';

// const UserSignup = ({ onClose }) => {
//   const [showLogin, setShowLogin] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     password: '',
//     referredBy: '',
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);
//   // const navigate = useNavigate();

//   if (showLogin) {
//     return <UserLogin onClose={onClose} setShowLogin={setShowLogin} />;
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);
//     setMessage(null);

//     try {
//       const response = await registerUser(formData);
//       setMessage(response.msg || 'Signup successful! Please check your email to verify your account.');
//       setFormData({ name: '', email: '', password: '', referredBy: '' });
//     } catch (err) {
//       console.error("Registration error:", err);

//       if (err.response && err.response.data && err.response.data.msg) {
//         setError(err.response.data.msg);
//       } else if (err.message) {
//         setError(err.message);
//       } else {
//         setError("Signup failed.");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50 pt-10 px-4">
//       <div className="relative bg-white p-6 rounded shadow-xl w-full max-w-md animate-slide-down">
//         <button onClick={onClose} className="absolute top-5 right-5 text-gray-500 hover:text-red-500">
//           <X size={22} />
//         </button>
//         <h2 className="text-xl font-semibold mb-4 text-center">Create your account</h2>
//         <p className="text-sm text-gray-700 text-center mb-3">
//           Already have an account?{' '}
//           <button onClick={() => setShowLogin(true)} className="text-blue-600 hover:underline">
//             Log in here
//           </button>
//         </p>

//         {message && <p className="text-green-500 text-sm mb-3">{message}</p>}
//         {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

//         <form onSubmit={handleSubmit} className="space-y-3">
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             placeholder="Name"
//             onChange={handleChange}
//             required
//             className="border p-2 w-full rounded"
//           />
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             placeholder="Email"
//             onChange={handleChange}
//             required
//             className="border p-2 w-full rounded"
//           />
//           <div className="relative">
//             <input
//               type={showPassword ? 'text' : 'password'}
//               name="password"
//               value={formData.password}
//               placeholder="Password"
//               onChange={handleChange}
//               required
//               className="border p-2 w-full rounded pr-10"
//             />
//             <button
//               type="button"
//               onClick={() => setShowPassword((prev) => !prev)}
//               className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
//             >
//               {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//             </button>
//           </div>
//           <input
//             type="text"
//             name="referredBy"
//             placeholder="Referral Code (optional)"
//             value={formData.referredBy}
//             onChange={handleChange}
//             className="border p-2 w-full rounded"
//           />
//           <button
//             type="submit"
//             className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded w-full transition duration-200"
//             disabled={loading}
//           >
//             {loading ? 'Signing up...' : 'Sign Up'}
//           </button>
//         </form>

//         <div className="my-4">
//           <GoogleUserLoginButton />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserSignup;

import React, { useState } from 'react';
import { X, Eye, EyeOff } from 'lucide-react';
import UserLogin from './UserLogin';
import GoogleUserLoginButton from './GoogleUserLoginButton';
import { registerUser } from '../api';

const UserSignup = ({ onClose }) => {
  const [showLogin, setShowLogin] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    referredBy: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  if (showLogin) {
    return <UserLogin onClose={onClose} setShowLogin={setShowLogin} />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      const response = await registerUser(formData);
      setMessage(response.msg || 'Signup successful! Please check your email to verify your account.');
      setFormData({ name: '', email: '', password: '', referredBy: '' });
    } catch (err) {
      console.error("Registration error:", err);

      if (err.response && err.response.data && err.response.data.msg) {
        setError(err.response.data.msg);
      } else if (err.message) {
        setError(err.message);
      } else {
        setError("Signup failed.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50 pt-10 px-4">
      <div className="relative bg-white p-6 rounded shadow-xl w-full max-w-md animate-slide-down">
        <button onClick={onClose} className="absolute top-5 right-5 text-gray-500 hover:text-primary-600 transition">
          <X size={22} />
        </button>
        <h2 className="text-xl font-semibold mb-4 text-center">Create your account</h2>
        <p className="text-sm text-gray-700 text-center mb-3">
          Already have an account?{' '}
          <button onClick={() => setShowLogin(true)} className="text-primary-600 hover:underline">
            Log in here
          </button>
        </p>

        {message && <p className="text-green-600 text-sm mb-3 text-center">{message}</p>}
        {error && <p className="text-red-500 text-sm mb-3 text-center">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="text"
            name="name"
            value={formData.name}
            placeholder="Name"
            onChange={handleChange}
            required
            className="border p-2 w-full rounded focus:outline-none focus:border-primary-500"
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            placeholder="Email"
            onChange={handleChange}
            required
            className="border p-2 w-full rounded focus:outline-none focus:border-primary-500"
          />
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={formData.password}
              placeholder="Password"
              onChange={handleChange}
              required
              className="border p-2 w-full rounded pr-10 focus:outline-none focus:border-primary-500"
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          <input
            type="text"
            name="referredBy"
            placeholder="Referral Code (optional)"
            value={formData.referredBy}
            onChange={handleChange}
            className="border p-2 w-full rounded focus:outline-none focus:border-primary-500"
          />
          <button
            type="submit"
            className="bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded w-full transition duration-200 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Signing up...' : 'Sign Up'}
          </button>
        </form>

        <div className="my-4">
          <GoogleUserLoginButton />
        </div>
      </div>
    </div>
  );
};

export default UserSignup;
